import { render, staticRenderFns } from "./ListBMHCForDisease.vue?vue&type=template&id=206da46b&scoped=true"
import script from "./ListBMHCForDisease.vue?vue&type=script&lang=js"
export * from "./ListBMHCForDisease.vue?vue&type=script&lang=js"
import style0 from "./ListBMHCForDisease.vue?vue&type=style&index=0&id=206da46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206da46b",
  null
  
)

export default component.exports